import * as Yup from "yup";

const nfSaidaIntermediadorValidator = Yup.object().shape({
  nomeRazaoSocial: Yup.string().required("Razão Social"),
  cnpjCpf: Yup.string().required("CNPJ"),
});

export default nfSaidaIntermediadorValidator;
